import { FC } from 'react';
import ErrorDisplay from '@base/lib/ErrorDisplay';
import { useTrans } from 'base/utils/i18n';

type IProps = {
    middle?: boolean;
}

const Custom404: FC<IProps> = ({ middle = false }) => {
    const { t } = useTrans();
    return <ErrorDisplay errorTip={t('web_common_page_not_found')} middle={middle}/>
}

export default Custom404;
